import type { TrigKey } from './keys';

export const id: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'Matematika · Trigonometri',
  'panel.experiment': 'Eksperimen',
  'panel.params': 'Parameter',
  'panel.scene': 'Pilih eksperimen',
  'experiment.right-triangle.label': 'Segitiga siku-siku',
  'experiment.unit-circle.label': 'Lingkaran satuan',
  'experiment.wave-studio.label': 'Studio gelombang',
  'experiment.identity-playground.label': 'Identitas',
  'experiment.triangle-solver.label': 'Penyelesai segitiga',
  'experiment.circular-polar.label': 'Lingkar & polar',
  'hint.line1': 'Seret titik dan geser slider.',
  'hint.line2': 'Konten pembelajaran ada di geometri, bukan di teks.',
  'rt.angle.a': 'Sudut A',
  'rt.angle.b': 'Sudut B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'Radian',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': 'Snap ke 30°/45°/60°',
  'uc.units': 'Satuan',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'Tampilkan ASTC',
  'uc.snap.common': 'Snap ke sudut umum',
  'uc.angle.value': '∠',
  'uc.units.deg': 'derajat',
  'uc.units.rad': 'rad',
  'uc.units.both': 'derajat+rad',
  'ws.fn': 'Fungsi',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — Amplitudo',
  'ws.frequency': 'B — Frekuensi',
  'ws.phase': 'C — Geser fase',
  'ws.shift': 'D — Geser vertikal',
  'ws.rform.toggle': 'Turunan bentuk R',
  'ws.rform.a': 'a (koef. sin)',
  'ws.rform.b': 'b (koef. cos)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'Atur ulang',
  'ws.base': 'Tampilkan kurva dasar',
  'ip.id.pythagorean': 'Pitagoras',
  'ip.id.reciprocal': 'Resiprokal',
  'ip.id.quotient': 'Hasil bagi',
  'ip.id.sum': 'Jumlah',
  'ip.id.difference': 'Selisih',
  'ip.id.double': 'Sudut ganda',
  'ip.id.half': 'Setengah sudut',
  'ip.play': 'Putar',
  'ip.pause': 'Jeda',
  'ip.step': 'Langkah',
  'ip.reset': 'Atur ulang',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'Hadir di v2 — bukti ini perlu konstruksi yang lebih lengkap.',
  'ts.area': 'Luas',
  'ts.sineRule': 'Aturan sinus',
  'ts.cosineRule': 'Aturan kosinus',
  'ts.ambiguous.toggle': 'Tampilkan segitiga hantu saat ambigu',
  'ts.reset': 'Reset ke sama sisi',
  'ts.snap.integers': 'Snap ke bilangan bulat',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'Sisi',
  'ts.section.angles': 'Sudut',
  'ts.section.sineRule': 'Aturan sinus',
  'ts.section.cosineRule': 'Aturan kosinus',
  'ts.section.area': 'Luas',
  'cp.omega': 'Kecepatan sudut',
  'cp.plot.y': 'Plot y (sin)',
  'cp.plot.x': 'Plot x (cos)',
  'cp.polar.label': 'Gambar polar',
  'cp.polar.circle': 'Lingkaran (r = 1)',
  'cp.polar.rose': 'Mawar (r = sin 3θ)',
  'cp.polar.cardioid': 'Kardioid (r = 1 + cos θ)',
  'cp.polar.limacon': 'Limaçon (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'Pendekatan sudut kecil (sin x ≈ x)',
  'cp.play': 'Putar',
  'cp.pause': 'Jeda',
  'cp.reset': 'Atur ulang',
  'cp.step': 'Langkah π/12',
};
